/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: "orderby"
})
export class OrderByPipe implements PipeTransform {
  transform(array: Array<string>, args: string): Array<any> {
    const field = args;
    array.sort((a: any, b: any) => {
      let fieldA, fieldB;
      for (const str of field.split(".")) {
        if (!(fieldA && fieldB)) {
          fieldA = a[str];
          fieldB = b[str];
        } else {
          fieldA = fieldA[str];
          fieldB = fieldB[str];
        }
      }
      if (fieldA < fieldB) {
        return -1;
      } else if (fieldA > fieldB) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}